import React from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import LeadTopFields from "@/pages/leads/components/LeadTopFields";
import { disqualifyModalMode, LeadData } from "@/pages/leads/types";
import { TopFieldsContext } from "@/components/layouts/TopFields";
import LeadKPIs from "@/pages/leads/components/LeadKPIs";
import LeadDetailFields from "@/pages/leads/components/LeadDetailFields/LeadDetailFields";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";
import Ownership from "@/components/layouts/Ownership";
import { useLeadTypes } from "@/pages/leads/hooks";
import { useLicenseServiceItems } from "@/entities/settings/hooks";

interface Props {
  lead: LeadData | undefined;
  onUpdateLeadField: (
    field: string,
    newValue: string | number | boolean | string[],
    additionalFields?:
      | {
          [fieldName: string]: string | number;
        }
      | undefined,
    successToastText?: string | undefined,
    onSuccessFn?: (() => void) | undefined,
    isDetailedView?: boolean | undefined,
    hideSuccessToast?: boolean | undefined,
    queryParams?: Record<string, string> | undefined
  ) => void;
  handleUnmarkAsStuck: () => void;
  handleOpenDisqualifyLeadModal: (
    mode: disqualifyModalMode,
    selectedReason?: number | null,
    notesInput?: string | null,
    selectedCompanyReason?: number | null
  ) => void;
  setView: React.Dispatch<
    React.SetStateAction<"companies" | "people" | "deals">
  >;
}

const LeadQuickViewContent: React.FC<Props> = ({
  lead,
  onUpdateLeadField,
  handleUnmarkAsStuck,
  handleOpenDisqualifyLeadModal,
  setView
}) => {
  const sources = useLeadTypes().data?.leadsTypes ?? [];
  const { licenseItems: licenseTypes } = useLicenseServiceItems();
  return (
    <div className="flex flex-col w-full gap-4">
      <LeadTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        lead={lead}
        onUpdateField={onUpdateLeadField}
        handleUnmarkAsStuck={handleUnmarkAsStuck}
        handleOpenDisqualifyLeadModal={handleOpenDisqualifyLeadModal}
        licenseTypes={licenseTypes}
        context={
          {
            setView,
            onCompanySelect: (companyId: string) => {
              onUpdateLeadField("companyId", companyId);
            }
          } as TopFieldsContext
        }
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <LeadKPIs
          key={lead?.id}
          lead={lead}
          containerClassName="grid-cols-[repeat(auto-fill,minmax(12rem,12rem))]"
          isQuickView
        />
        <LeadDetailFields
          className="w-full px-4"
          lead={lead}
          onUpdateField={onUpdateLeadField}
          isDrawerOpen={true}
          isQuickView
          sources={sources}
          licenseTypes={licenseTypes}
        />
        <NextSteps
          className="w-full px-4"
          entity={lead}
          entityType={EntityType.LEAD}
          isQuickView
        />
        <Ownership
          entity={lead}
          entityType={EntityType.LEAD}
          onUpdateField={onUpdateLeadField}
          isQuickView
        />
      </div>
    </div>
  );
};

export default LeadQuickViewContent;
